import { render, staticRenderFns } from "./AamsLetterUsageRecord.vue?vue&type=template&id=387a8563&scoped=true&"
import script from "./AamsLetterUsageRecord.vue?vue&type=script&lang=js&"
export * from "./AamsLetterUsageRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a8563",
  null
  
)

export default component.exports